import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const ConfigCtx = createContext({ whatsapp: "", phone: "", email: "" });

export function ConfigProvider({ children }) {
  const [config, setConfig] = useState({ whatsapp: "", phone: "", email: "" });
  useEffect(() => {
    api
      .get("/config")
      .then((res) => setConfig(res.data))
      .catch(() => {});
  }, []);
  return <ConfigCtx.Provider value={config}>{children}</ConfigCtx.Provider>;
}

export const useConfig = () => useContext(ConfigCtx);
